import React, { useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { close, open } from '../../redux/layerSlice';
import { LayerPosition } from '../../types';
import VideoPopupLayer from './VideoPopupLayer';

const HealingContents: React.FC = () => {
    const dispatch = useAppDispatch();
    const [style, setStyle] = useState<LayerPosition>({
        display: '',
        left: '',
        top: '',
    });
    const isOpen = useAppSelector(state => state.layer.isOpen);
    const popLayerOpen = (src: string) => {
        dispatch(open(src));
        popupCenter();
    }

    const popupCenter = () => {
        let divWidth = document.getElementById("popupBox")?.offsetWidth;
        let divHeight = document.getElementById("popupBox")?.offsetHeight;
        if (divWidth && divHeight) {
            setStyle({
                display: "block",
                left: (window.innerWidth - divWidth) / 2 + "px",
                top: (window.innerHeight - divHeight) / 2 + "px",
            })
        }
    }
    
    const popupClose = () => {
        setStyle({
            display: '',
            top: '',
            left: '',
        })
        dispatch(close());
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>힐링컨텐츠</h2>
                        <Location 
                            locations={[
                                {title: "토닥토닥마음케어", url: "/column/columnList"}
                            ]}
                            menuName='힐링컨텐츠'
                        />
                        <div className="mobileface healing">
                            <p className="green f18 lh24 mb30 bold">“마음의 쉼표, 힐링 컨텐츠로 마음을 치유하세요.”</p>
						    <div className="vodbox mt30">
                                <ul>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/252838393.hd.mp4?s=e22d66a19f0a3d92420c5a7eed1b83c0d23d331a&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod001.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 마음이 평온해지길 <strong>바람</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/252840603.hd.mp4?s=2604473f29647db7039f90019b1fba8bcbccbc38&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod002.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 근심은 흐르는 <strong>계곡으로</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/252842481.hd.mp4?s=504e0a3481a388bcc78ee27e0b72c5c246928c00&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod003.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 마음을 닦는 <strong>사찰에서</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/252844179.hd.mp4?s=94bea0baba06eeb9cdc86e76d410d7a0f8279bfe&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod004.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 지친 마음에 <strong>파도</strong>의 시원함을1</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253170709.hd.mp4?s=fd5fdcd3c794cf66316aaab9989c4f86db060859&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod005.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 지친 마음에 <strong>파도</strong>의 시원함을2</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253172449.hd.mp4?s=a4b4b19d28adaf32dec146fd333cb4caa6b7bdfb&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod006.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 언젠가 멈출 <strong>비</strong> 처럼</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253174819.hd.mp4?s=e4ceeba84b7b91bdda92248e31419878034ae979&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod007.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 내 마음에 따뜻한 <strong>촛불하나</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253179601.hd.mp4?s=5d6249f3017c433ccfe8b6f99c0cacdeea3d7499&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod008.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 내 마음 따뜻한 <strong>차 한잔</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253181147.hd.mp4?s=a3ac4740fe72f487c8d717b8f09b47a9c668ff9d&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod009.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 당신에게 <strong>모닥불</strong>과 같은 온기를...</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253193312.hd.mp4?s=1b9d4d6dd178f034bb1785b7668413bd95a24f05&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod010.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, <strong>고양이</strong>의 하루</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253194803.hd.mp4?s=e7977a2ec83583191d237d5a6676f01e1dc9e04c&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod011.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, <strong>시처럼 음악처럼1</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253196470.hd.mp4?s=47ae7e14666b8cb50220428ce0042c41dcff7ee7&profile_id=175")}className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod012.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, <strong>시처럼 음악처럼2</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253197597.hd.mp4?s=81db21d095eb2dafb407ef1fdf100dc8e688f44d&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod013.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 세상이 <strong>조용</strong>해지는 시간</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253198999.hd.mp4?s=d47c8dc5250a2bd9b9c23db0e079502c62d2097b&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod014.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 마음을 비워주는 <strong>커피 한 잔</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253200459.hd.mp4?s=bb01f69949aca69235e284596e123c7b52c56a7c&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod015.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 어둠을 밝히는 작은 <strong>불빛들</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={() => popLayerOpen("https://player.vimeo.com/external/253201590.hd.mp4?s=9534e935df8727711a14bdbb7d3e830a915d956d&profile_id=175")} className="popOpen">
                                            <span className="vodimg"><img src="/images/therapy/therapy_vod016.png" alt="" /></span>
                                            <span className="subsc">마음의 쉼표, 서울의 <strong>밤</strong></span>
                                        </a>
                                    </li>
                                </ul>
						    </div>
                        </div>
                    </div>
                </div>
            </section>
            <VideoPopupLayer style={style} popupClose={popupClose}/>
            <div className='dimmed' style={{display: isOpen? "block" : "none"}}></div>
            <Footer />
        </div>
    )
}

export default HealingContents;